"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M3 5c0-1.6568 1.3431-3 3-3h6c1.6569 0 3 1.3432 3 3v2h-2V5c0-.5523-.4477-1-1-1H6c-.5523 0-1 .4477-1 1v14c0 .5523.4477 1 1 1h6c.5523 0 1-.4477 1-1v-2h2v2c0 1.6569-1.3431 3-3 3H6c-1.6569 0-3-1.3431-3-3V5z"
  }), _react.default.createElement("path", {
    d: "M8 18c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1zm11.743-.0951c-.5485-.2075-.7955-.8417-.5835-1.3885.543-1.4008.8408-2.9238.8408-4.5165 0-1.5923-.2977-3.1152-.8406-4.5158-.2119-.5468.0351-1.181.5836-1.3884.4834-.1828 1.0298.0342 1.2221.514.6577 1.6414 1.0239 3.4311 1.0347 5.305v.1704c-.0108 1.8743-.3772 3.6642-1.0351 5.3059-.1922.4797-.7386.6967-1.222.5139zm-3.7275-1.4098c.4688.1773 1.001-.0234 1.1925-.4866.5106-1.2351.7923-2.589.7923-4.0086 0-1.4193-.2816-2.7728-.792-4.0078-.1914-.4632-.7236-.664-1.1925-.4866-.5614.2123-.8001.8723-.5838 1.4322.3671.9501.5683 1.9827.5683 3.0622 0 1.0798-.2013 2.1126-.5685 3.0629-.2164.5599.0223 1.2199.5837 1.4323zm-2.5888-1.8214c-.1897.4197-.6828.584-1.1137.421-.5913-.2236-.8022-.9555-.5851-1.5493a4.49 4.49 0 0 0 .2724-1.5455c0-.5427-.0961-1.063-.2721-1.5448-.2171-.5938-.0062-1.3256.5851-1.5492.4309-.163.9241.0013 1.1138.4211.3683.8153.5732 1.7202.5732 2.6729 0 .9531-.2051 1.8583-.5736 2.6738z"
  })];
};

exports.default = _default;